import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MONETIZATION_BANDIT_COMBO_EXP = defineFcm('monetization_bandit_combo_exp')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'corgi-front-end',
		context: 'Combo Page',
		description: 'Enables the bandit hard coded experiment',
		import: false,
		template: {
			experiment_name: 'my_experiment_name',
		},
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
